// Generated by CoffeeScript 2.7.0
var DebounceInput;

export default DebounceInput = Vue.extend({
  props: {
    placeholder: {
      type: String,
      default: '请输入'
    },
    value: {
      type: String,
      default: ''
    },
    debounceDelay: {
      type: Number,
      default: 600
    },
    typeClasses: {
      type: [Array, String]
    },
    readonly: Boolean
  },
  template: `<input type="text"
       :class='typeClasses'
       :placeholder='placeholder'
       :value='value'
       :readonly='readonly'
       ref='input'
       @input='inputChange' />`,
  created: function() {
    return this._debounceFunc = _.debounce(this.change, this.debounceDelay);
  },
  methods: {
    change: function(event) {
      return this.$emit('change', event.target.value);
    },
    inputChange: function(event) {
      return this._debounceFunc(event);
    },
    clear: function() {
      this.$refs.input.value = '';
      return this.$emit('change', '');
    }
  }
});
